function updateDocTableExpandableTreeRailForRow(detailRow) {
  var inner = detailRow.querySelector('.doc-table-expandable__detail-inner');
  if (!inner) {
    return;
  }
  if (
    detailRow.hasAttribute('hidden') ||
    detailRow.classList.contains('doc-table-expandable__detail-row--collapsed')
  ) {
    inner.classList.remove('doc-table-expandable__detail-inner--tree-rail-capped');
    inner.style.removeProperty('--tree-rail-height');
    return;
  }
  var titles = inner.querySelectorAll('.doc-table-expandable__section--title');
  if (!titles.length) {
    inner.classList.remove('doc-table-expandable__detail-inner--tree-rail-capped');
    inner.style.removeProperty('--tree-rail-height');
    return;
  }
  var lastTitle = titles[titles.length - 1];
  var innerRect = inner.getBoundingClientRect();
  var titleRect = lastTitle.getBoundingClientRect();
  var fontSize = parseFloat(window.getComputedStyle(lastTitle).fontSize) || 14;
  // Match _table.scss: horizontal branch at top: 0.65em on the title row
  var branchY = titleRect.top - innerRect.top + 0.65 * fontSize;
  var heightPx = Math.max(1, Math.ceil(branchY));
  inner.style.setProperty('--tree-rail-height', heightPx + 'px');
  inner.classList.add('doc-table-expandable__detail-inner--tree-rail-capped');
}

function updateDocTableExpandableTreeRails(root) {
  var scope = root || document;
  var rows = scope.querySelectorAll(
    '.doc-table-expandable__detail-row:not(.doc-table-expandable__detail-row--collapsed)'
  );
  for (var i = 0; i < rows.length; i++) {
    updateDocTableExpandableTreeRailForRow(rows[i]);
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages
    let $path = window.location.pathname;
    let $path_name = $path.substring(0, $path.lastIndexOf('/') + 1);

    var treeRailResizeTimer;
    $(window).on('resize.docTableExpandableTreeRail', function () {
      clearTimeout(treeRailResizeTimer);
      treeRailResizeTimer = setTimeout(function () {
        updateDocTableExpandableTreeRails();
      }, 100);
    });

    // Expandable documentation tables
    $(document).on('click', '[data-doc-table-expandable-toggle]', function () {
      var $btn = $(this);
      var detailId = $btn.attr('aria-controls');
      var $detail = detailId ? $('#' + $.escapeSelector(detailId)) : $();
      if (!$detail.length) {
        return;
      }
      var expanded = $btn.attr('aria-expanded') === 'true';
      $btn.attr('aria-expanded', expanded ? 'false' : 'true');
      if (expanded) {
        $detail.attr('hidden', true).addClass('doc-table-expandable__detail-row--collapsed');
        updateDocTableExpandableTreeRailForRow($detail[0]);
      } else {
        $detail.removeAttr('hidden').removeClass('doc-table-expandable__detail-row--collapsed');
        window.requestAnimationFrame(function () {
          updateDocTableExpandableTreeRailForRow($detail[0]);
        });
      }
    });

    updateDocTableExpandableTreeRails();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        updateDocTableExpandableTreeRails();
      });
    }

    // Dropdown Section
    $('.dropdown-section__select').on('change', function() {
      let $dropdown_section = $(this).val();
      let $selection_text = this.options[this.selectedIndex].text;
      let $section_title = $(this).parents('.doc-block__dropdown-section').find('.dropdown-section__heading').text();

      console.log('Documentation Page: '+ $path_name);
      console.log('Documentation Dropdown Section ID: '+ $(this).data('content-block-id'));
      console.log('Documentation Dropdown Section Title:'+ $section_title);
      console.log('Documentation Dropdown Value: '+ $selection_text);

      $('.dropdown-section__content-blocks__block').removeClass('active');      
      $('.dropdown-section__content-blocks__block[data-blockid="'+ $dropdown_section +'"]').addClass('active');

    });

    // Mobile Menu
    $('.btn--mobile-trigger, .btn--mobile-trigger--close').on('click', function(e) {
      e.preventDefault();

      $('.mobile-menu').toggleClass('active');
    });

    $('.btn--mobile-trigger--search, .btn--mobile-trigger--search--close').on('click', function(e) {
      e.preventDefault();

      $('.mobile-search').toggleClass('active');
    });

    $('.mobile-trigger--main-sidebar--open-close').on('click', function(e) {
      e.preventDefault();

      $('.main-sidebar').toggleClass('active');
      $('.mobile-trigger--main-sidebar').toggleClass('open');
    });

    // Table of Contents Smooth Scrolling
    var linkElements = document.querySelectorAll('.table-of-contents__link');

    for (var i = 0; i < linkElements.length; i++) {
        linkElements[i].addEventListener('click', function(e) {
            e.preventDefault();
            
            var anchor = document.querySelector(e.target.hash);
            console.log(anchor);
            anchor.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
        });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js